import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 80 59" fill="none" stroke="black" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 14.1657C1 14.1657 3.93617 12.4032 7.88608 10.1606C13.8757 6.7599 22.5639 2.45482 26.1452 1.11865" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M32.0887 1.43311C32.0887 1.43311 21.7258 7.87802 20.3543 8.66402C18.9828 9.45002 18.3731 10.0788 16.2396 10.0788C14.1061 10.0788 7.88623 10.1606 7.88623 10.1606"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M42.147 1.27588C42.147 1.27588 29.5743 7.64221 29.2696 7.79938L29.041 10.8646L50.9859 11.1004L52.2813 7.7993" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M50.3764 37.509C50.3764 37.509 49.4537 30.283 53.0433 26.7413C56.5484 23.283 57.6152 19.8248 58.0724 18.1743C58.5296 16.5238 61.1965 13.4585 64.1682 13.5371"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M73.9215 18.3314C69.6618 18.2236 66.1335 22.8725 65.4782 25.1364C64.8229 27.4003 62.9182 31.5419 58.2694 36.8871C52.7385 43.2465 56.777 51.1848 56.777 51.1848C56.777 51.1848 37.7276 48.1196 33.8415 48.5125C29.9554 48.9055 28.2029 47.2549 28.8887 44.8185C29.5744 42.382 30.6413 36.9588 30.946 35.9371C31.2508 34.9153 33.2319 32.0073 40.4708 33.815C47.7096 35.6228 50.3003 37.6663 50.3003 37.6663L56.2437 49.9273"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M72.702 14.4801C72.702 14.4801 69.4255 16.1306 65.6918 14.2444C61.9581 12.3581 61.0437 11.5721 60.6627 8.19244C60.2817 4.81277 62.4153 2.69069 63.4058 2.21911C64.3964 1.74752 70.2636 -0.846142 71.4828 1.43311C72.702 3.71236 76.8928 13.0654 72.702 14.4801Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M69.4257 0.647217C67.216 1.04022 67.0635 3.08372 66.9112 4.02688C66.7588 4.97005 66.1492 10.5504 68.4351 13.0655C70.721 15.5805 73.0832 14.2444 73.0832 14.2444L74.8358 15.3447"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.6322 10.8053C58.6322 10.8053 56.9179 11.6688 54.9644 10.6819C53.0109 9.69501 52.5325 9.28376 52.3331 7.51543C52.1338 5.74718 53.25 4.63685 53.7684 4.3901C54.2867 4.14335 57.3565 2.78635 57.9944 3.97885C58.6323 5.17135 60.825 10.065 58.6322 10.8053Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M56.918 3.56763C55.7618 3.77321 55.682 4.84246 55.6023 5.33588C55.5225 5.82938 55.2036 8.74904 56.3996 10.065C57.5956 11.381 58.8315 10.6819 58.8315 10.6819L59.7485 11.2576C59.7485 11.2576 61.6534 12.8295 60.5866 14.7159"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M79.1791 0.72583C79.1791 0.72583 69.3496 40.9673 53.729 58.18" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M31.3268 58.2584C31.3268 58.2584 26.5264 53.6212 28.6599 45.9973" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M55.1768 1.19727L53.7686 4.3901" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M46.7681 25.012C46.7771 23.4392 47.041 20.9394 48.47 19.4465C50.6212 17.1992 51.276 14.9518 51.5566 13.8792C51.8371 12.8066 53.474 10.8146 55.2979 10.8657"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M33.7339 28.7751C34.0889 27.5601 34.4551 26.3732 34.6031 25.8767C34.7902 25.2496 35.9126 23.0789 40.3555 24.1884C42.3136 24.6774 43.7818 25.1702 44.8115 25.5685"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M60.2172 12.3169C57.6028 12.2468 55.4373 15.2679 55.0352 16.7391C54.633 18.2104 53.4639 20.9018 50.6107 24.3755C50.4649 24.553 50.3299 24.7325 50.2051 24.9134"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M44.585 32.1644C44.585 32.1644 42.6801 27.6058 43.1373 26.7412C43.5944 25.8766 46.3376 24.2261 53.9573 25.4836" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M50.3001 32.243C50.3001 32.243 29.8029 32.243 28.4314 32.243C27.0598 32.243 24.1643 31.7714 23.5547 28.156" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M1 29.2563C1 29.2563 3.36217 27.9202 5.1845 26.9331C6.07358 26.4515 6.41 26.2696 7.32442 25.6408C8.32683 24.9515 8.315 24.3833 8.08642 23.4402C7.69442 21.8227 8.40125 15.8923 14.7156 12.0437C18.0432 10.0154 18.802 12.1165 18.9346 13.7704"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M20.4304 30.2781L1.07617 48.5125" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.84863 41.5173C8.84863 41.5173 9.83922 43.7967 13.8777 43.7967C17.9162 43.7967 28.8125 44.3468 28.8125 44.3468" stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.0287 18.5934C32.9456 24.5954 33.3975 30.3906 31.0379 31.5373C28.6783 32.684 24.4009 28.7481 21.484 22.7461C18.5671 16.744 18.1152 10.9488 20.4748 9.80212C22.8344 8.65539 27.1118 12.5914 30.0287 18.5934Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.7162 18.4099C23.3258 18.0169 23.4782 18.0169 24.7735 17.9383C26.0688 17.8597 27.1105 16.6423 27.1105 16.6423C24.9483 12.9606 22.6731 10.6298 21.6082 11.1867C20.3192 11.861 21.2918 16.5114 23.7804 21.5737C26.2692 26.6361 29.3317 30.1934 30.6207 29.5191C31.2465 29.1918 31.3393 27.9273 30.9843 26.1335C30.9843 26.1335 28.8882 24.0688 29.2692 28.5488"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.8166 19.9011C29.4301 21.2191 29.9361 22.496 30.321 23.6671C30.321 23.6671 29.5742 24.069 28.6599 22.104C27.7456 20.1391 28.8166 19.9011 28.8166 19.9011Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M25.6118 24.4619C25.6118 24.4619 26.7548 23.5973 27.2881 24.8549C27.8216 26.1125 27.8216 27.5272 27.8216 27.5272" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M43.3659 29.0991L32.6221 28.7847" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12.9507 33.2363C12.9507 33.2363 20.7351 30.8282 24.0116 27.6057" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M19.9073 19.0693C19.9073 19.0693 15.4363 21.2316 13.486 22.3811C9.74025 24.5889 6.63867 27.9987 6.63867 27.9987" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default Icon;
